import type { ActKc2Data, BimActKc2OtherItemData, ActKc2NavData } from 'gql/graphql';
import { Badge } from 'uikit';
import { descriptionNumberAndDate } from 'utils/descriptionNumberAndDate';

import type React from 'react';

import { getActKC2StatusColor, getActKC2StatusLabel } from '../types';

import Style from './ActKc2Title.module.css';

export const formatActTitle = (number?: number | string | null, date?: Date): `Акт${string}` =>
    `Акт${descriptionNumberAndDate(number, date)}`;

interface IActKc2Title {
    act: ActKc2Data | BimActKc2OtherItemData | ActKc2NavData;
    size?: 's' | 'm' | 'xs' | 'l';
    includeTitle?: boolean;
    badgeStyle?: React.CSSProperties;
    titleStyle?: React.CSSProperties;
}

export const ActKc2Title: React.FC<IActKc2Title> = (props) => {
    const { size, act, includeTitle, badgeStyle, titleStyle } = props;
    const { status, number, date, correctionDate, isInactive, isCorrection, fullNumber } = act as ActKc2Data;

    return (
        <div className={Style.actKc2Title}>
            <Badge
                minified
                size={size}
                label={getActKC2StatusLabel(status)}
                status={getActKC2StatusColor(status)}
                className={getActKC2StatusColor(status) === 'progress' ? 'BadgeColor_progress' : undefined}
                style={badgeStyle}
            />
            {includeTitle && (
                <div
                    style={titleStyle}
                    className={`Text Text_lineHeight_m Text_size_s ${
                        isInactive ? 'Text_view_secondary' : 'Text_view_primary'
                    } Collapse-LabelText ${Style.title}`}
                >
                    {formatActTitle(isCorrection ? fullNumber : number, isCorrection ? correctionDate : date)}
                </div>
            )}
        </div>
    );
};

ActKc2Title.displayName = 'ActKc2Title';
